import { UmbValueSummaryApiBase } from '../base/value-summary-api.base.js';

/**
 * Default value summary API implementation.
 * Provided by the `default` kind for `valueSummary` extensions.
 */
export class UmbValueSummaryDefaultApi<ValueType = unknown> extends UmbValueSummaryApiBase<ValueType> {}
